import { createApp } from 'vue'
import { createPinia } from 'pinia'

// ⭐ 引入 Varlet UI
import Varlet from '@varlet/ui'
import '@varlet/ui/es/style'

// ⭐ 引入 Varlet 图标
import '@varlet/icons'

// ⭐ 桌面端适配（Varlet 官方提供）
import '@varlet/touch-emulator'

// ⭐ 引入自定义样式（覆盖 Varlet 样式）
import './style.css'

import router from './router'
import App from './App.vue'

// ✅ 直接从模块导入全局响应式属性（不需要调用 useDevice）
import { isMobile, isDesktop, initDeviceListener } from '@/composables/useDevice'

// ⭐ 导入配置
import { setupVarlet } from './plugins/varlet'

import { assetUrl } from "./utils/helpers.js";

// ✅ Capgo 热更新插件（仅在原生 App 环境中生效）
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { Capacitor } from '@capacitor/core'

// ✅ 初始化设备监听
initDeviceListener()

const app = createApp(App)

// ✅ 注册全局属性
Object.defineProperty(app.config.globalProperties, '$isMobile', {
  get() {
    return isMobile.value
  }
})
Object.defineProperty(app.config.globalProperties, '$isDesktop', {
  get() {
    return isDesktop.value
  }
})
app.config.globalProperties.$assetUrl = assetUrl

app.use(createPinia())
app.use(router)
app.use(Varlet)

// ⭐ Varlet 额外配置
setupVarlet(app)

// ============================================================
// ✅ Capgo 热更新：通知 App 启动成功
// 必须在 mount 后、10 秒内调用，否则插件会自动回滚到旧版本
// Web 端（Capacitor.isNativePlatform() === false）不调用，避免报错
// ============================================================
if (Capacitor.isNativePlatform()) {
  CapacitorUpdater.notifyAppReady()
    .then(() => console.log('[Capgo] notifyAppReady OK'))
    .catch(err => console.error('[Capgo] notifyAppReady 失败:', err))
}

app.mount('#app')